import { render, staticRenderFns } from "./SignatureSettings.vue?vue&type=template&id=12b9bfac&scoped=true"
import script from "./SignatureSettings.vue?vue&type=script&lang=js"
export * from "./SignatureSettings.vue?vue&type=script&lang=js"
import style0 from "./SignatureSettings.vue?vue&type=style&index=0&id=12b9bfac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b9bfac",
  null
  
)

export default component.exports